import React, { useCallback, useState, useEffect } from "react";
import { Button, Accordion, AccordionItem, AccordionHeader, AccordionPanel, Field, Select , Text, makeStyles, Badge } from "@fluentui/react-components";
import { BuildingMultipleRegular, BuildingRegular, PeopleCommunityRegular, StepRegular, SubtractSquareRegular, AddSquareRegular } from "@fluentui/react-icons";

import Stack from "./Stack";
import { useTranslation } from "react-i18next";
import {
  defaultFunction,
  autoSetPlace,
  autoSetSite,
  autoSetBuilding,
  autoSetFloor,
  getAmenitieImage
} from "../common/utilities/utilities";
import { connect } from "react-redux";

const useStyles = makeStyles({
  root: {
    gridTemplateColumns: '60% 1fr'
  },
});


function Filters(props) {
  const {
    sites = [],
    handleApplyFilters = defaultFunction,
  } = props


  const styles = useStyles();
  const { t } = useTranslation()
  const [site, setSite] = useState("")
  const [building, setBuilding] = useState("")
  const [floor, setFloor] = useState("")
  const [buildings, setBuildings] = useState([])
  const [floors, setFloors] = useState([])
  const [amenities, setAmenities] = useState([])
  const [capacity, setCapacity] = useState(0);
  const [openItems, setOpenItems] = useState(["0"]);

   const setPlaceMethods = {
    sites,
    buildings,
    floors,
    setSite,
    setBuildings,
    setBuilding,
    setFloors,
    setFloor,
  };

  // useEffect(() => {
  //   autoSetPlace(sites, setPlaceMethods);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onChangeSite = (_, { value }) => autoSetSite(value, setPlaceMethods);
  const onChangeBuilding = (_, { value }) => autoSetBuilding(value, setPlaceMethods);
  const onChangeFloor = (_, { value }) => autoSetFloor(value, setPlaceMethods);


  const onAddCapacity = () => {
    setCapacity(prev => prev + 1);
  }

  const onSubtractCapacity = () => {
    setCapacity(prev => {
      if (prev > 0) return prev - 1;
      return 0;
    });
  }

  const handleToggle = (event, data) => {
    setOpenItems(data.openItems);
  };

  const applyFilters = useCallback(() => {
    setOpenItems(["0"])
    handleApplyFilters({
      site,
      building,
      floor,
      capacity,
      amenities,
      filtered: true,
    });
  }, [handleApplyFilters, site, building, floor, capacity, amenities]);

  const clearFilters = useCallback(() => {
    const site = "";
    const building = "";
    const floor = "";
    const capacity = 0;
    const amenities = [];

    setOpenItems(["0"])
    setSite(site);
    setBuilding(building);
    setBuildings([]);
    setFloors([]);
    setFloor(floor);
    setCapacity(capacity);
    setAmenities(amenities);

    handleApplyFilters({
      site,
      building,
      floor,
      capacity,
      amenities,
      filtered: false,
    });
  }, [handleApplyFilters, setBuildings, setFloors]);

  const getAllAmenities = (numberOfAmenities) => {
    let amenitiesComponents = [];
    for (let i = 0; i < numberOfAmenities; i++) {
      const amenityIndex = i;
      const isSelected = amenities.includes(amenityIndex);
      amenitiesComponents.push(
        <Badge
          key={i}
          className="ammenitie-bag"
          shape="rounded"
          color="informative"
          appearance={isSelected ? "filled" : "outline"}
          onClick={() => handleChangeAmenities(amenityIndex)}
        >
          <Stack tokens={{ childrenGap: 10 }} verticalAlign="center" horizontal>
            {getAmenitieImage(i, t)}
            <label>{t(getAmenitieImage(i, t).props.title)}</label>
          </Stack>
        </Badge>
      );
    }
    return amenitiesComponents;
  };

  return (
    <Accordion
      collapsible
      openItems={openItems}
      onToggle={handleToggle}
      >
      <AccordionItem value="1">
        <AccordionHeader size="small">{t("Filter room")}</AccordionHeader>
        <AccordionPanel>
          <Stack direction="column" gap="16px">
            <Field
              label={
                <Stack direction="row" gap="4px" alignItems="center" style={{ minWidth: "200px" }} >
                  <BuildingMultipleRegular />
                  <Text size={100}>SITIO</Text>
                </Stack>
              }
              orientation="horizontal"
            >
              <Select 
                style={{ minWidth: "80px" }}
                size="small"
                appearance="filled-darker"
                onChange={onChangeSite}
                value={site}
              >
                <option value="">{t('all')}</option>
                {sites?.map(s =>
                  <option
                    key={s.id}
                    value={s.id}>
                    {s.name}
                  </option>
                )}
              </Select >
            </Field>
            <Field
              label={
                <Stack direction="row" gap="4px" alignItems="center" style={{ minWidth: "200px" }} >
                  <BuildingRegular />
                  <Text size={100}>EDIFICIO</Text>
                </Stack>
              }
              orientation="horizontal"
            >
              <Select
                style={{ minWidth: "80px" }}
                size="small"
                appearance="filled-darker"
                onChange={onChangeBuilding}
                value={building}
              >
                <option value="">{t('all')}</option>
                {buildings?.map(s =>
                  <option
                    key={s.id}
                    value={s.id}>
                    {s.name}
                  </option>
                )}
              </Select >
            </Field>
            <Field
              label={
                <Stack direction="row" gap="4px" alignItems="center" style={{ minWidth: "200px" }} >
                  <StepRegular />
                  <Text size={100}>PISO</Text>
                </Stack>
              }
              orientation="horizontal"
            >
              <Select
                style={{ minWidth: "80px" }}
                size="small"
                appearance="filled-darker"
                onChange={onChangeFloor}
                value={floor}
              >
                <option value="">{t('all')}</option>
                {floors?.map(s =>
                  <option
                    key={s.id}
                    value={s.id}>
                    {s.name}
                  </option>
                )}
              </Select >
            </Field>
            {/* <Field
              label={
                <Stack direction="row" gap="4px" alignItems="center" style={{ minWidth: "200px" }} >
                  <AppFolderRegular />
                  <Text size={100}>AMENIDADES</Text>
                </Stack>
              }
              orientation="horizontal"
            >

            </Field> */}
            <Field
              className={styles.root}
              label={
                <Stack direction="row" gap="4px" alignItems="center" style={{ minWidth: "200px" }} >
                  <PeopleCommunityRegular />
                  <Text size={100}>{t("People capacity")}</Text>
                </Stack>
              }
              orientation="horizontal"
              style={{ justifyContent: "space-between" }}
            >
              <Stack direction="row" gap="8px">
                <Button
                  size="small"
                  appearance="primary"
                  onClick={onSubtractCapacity}
                  icon={<SubtractSquareRegular />}
                />
                <Button size="small">{capacity}</Button>
                <Button
                  size="small"
                  appearance="primary"
                  onClick={onAddCapacity}
                  icon={<AddSquareRegular />}
                />
              </Stack>
            </Field>
            <Stack direction="row" gap="8px" justifyContent="space-between">
              <Button 
                appearance="outline"
                size="small"
                onClick={clearFilters}
              >{t("Clear filters")}</Button>
              <Button 
                appearance="primary"
                size="small"
                onClick={applyFilters}
              >{t("Apply filters")}</Button>
            </Stack>
          </Stack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  )
}

const mapStateToProps = state => {
  return {
    sites: state.workplace.sites,
  }
}

export default connect(mapStateToProps, null)(Filters)